module.exports = __webpack_public_path__ + "media/nivel1.8a06324d.png";